module.exports = __webpack_public_path__ + "static/zqb.941b4a2f.png";